import { render, staticRenderFns } from "./ExternalStatistics.vue?vue&type=template&id=28124f98&scoped=true&"
import script from "./ExternalStatistics.vue?vue&type=script&lang=js&"
export * from "./ExternalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28124f98",
  null
  
)

export default component.exports